import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import * as Icons from '@spotnana/pixel-react/dist/Icons';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';
import { airTranslationKeys } from 'obt-common';
import { container, justifyStart, justifyCenter } from './styles';

import { CabinName } from '../styles';

const DangerCabinName = styled(CabinName).attrs({
  color: spotnanaTheme.colors.error,
})`
  margin-right: 4px;
`;

interface IProps {
  justifyContent?: 'center' | 'flex-start';
}

const MixedCabinHeader = ({ justifyContent }: IProps) => {
  const { t: tFlights } = useTranslation('FLIGHTS');

  return (
    <div css={[container, justifyContent === 'center' ? justifyCenter : justifyStart]} data-testid="mixed-cabin-name">
      <DangerCabinName>{tFlights(airTranslationKeys.MIXED_CABIN)}</DangerCabinName>
      <Icons.Caution primaryColor={spotnanaTheme.colors.error} width="17" height="17" />
    </div>
  );
};

export default MixedCabinHeader;
